import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=427bf6c7&scoped=true&"
import script from "./RightPanel.vue?vue&type=script&lang=js&"
export * from "./RightPanel.vue?vue&type=script&lang=js&"
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=427bf6c7&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427bf6c7",
  null
  
)

export default component.exports